module.exports = __webpack_public_path__ + "img/vartext1.8b40a2b7.svg";